import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
import { Price } from '../Price';
import { useCurrency } from '../../contexts/CurrencyContext';
export function CTASection() {
  const {
    convertPrice,
    currencyCode
  } = useCurrency();
  const price = 6.39;
  const originalPrice = 27;
  const handleAddToCart = () => {
    const convertedValue = Number(convertPrice(price).toFixed(2));
    trackAddToCart(convertedValue, currencyCode);
  };
  return <section id="final-cta" className="py-24 px-4 md:px-6 bg-cream-100 relative overflow-hidden" data-id="element-4">
      {/* Background blobs */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-white rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-5" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-6">
        {/* Risk Reversal */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/60 backdrop-blur-sm p-8 rounded-2xl border border-sage-light/30 mb-12" data-id="element-7">
          <ShieldCheck className="w-10 h-10 text-sage-DEFAULT mx-auto mb-4" data-id="element-8" />
          <h3 className="text-xl font-bold text-sage-dark mb-2" data-id="element-9">
            Risk-Free Guarantee
          </h3>
          <p className="text-sage-dark/80 max-w-2xl mx-auto" data-id="element-10">
            If you read the quick-start and try the reset for a few evenings and
            it doesn't help you feel more equipped, it wasn't a waste—you'll
            still walk away understanding why 4PM is so hard and which triggers
            were secretly fueling the cycle.
          </p>
        </motion.div>

        {/* Urgency */}
        <div className="mb-10" data-id="element-11">
          <p className="text-lg md:text-xl text-sage-dark font-medium italic" data-id="element-12">
            This is built for moms who want relief now, not after finishing a
            300-page parenting book.If 4PM has been scaring you lately… don't
            wait for the "perfect week."
          </p>
        </div>

        {/* Final CTA */}
        <div className="bg-sage-dark text-cream-50 rounded-3xl pt-20 md:pt-28 pb-10 md:pb-16 px-10 md:px-16 shadow-2xl relative overflow-hidden flex items-center justify-center" data-id="element-13">
          {/* Decorative circles inside CTA card */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-sage-light/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/3" data-id="element-14" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-terracotta/10 rounded-full blur-2xl translate-y-1/2 -translate-x-1/3" data-id="element-15" />

          <div className="relative z-10 w-full flex flex-col items-center text-center mt-16" data-id="element-16">
            <h2 className="text-3xl md:text-5xl font-bold font-serif mb-6 text-white" data-id="element-17">
              Try the 30-Minute Reset tonight
            </h2>
            <p className="text-xl text-sage-light/90 mb-6 max-w-2xl mx-auto" data-id="element-18">
              You don't need more discipline. You need a plan for the hardest
              time of day.
            </p>

            {/* Pricing */}
            <div className="mb-8 flex flex-col items-center" data-id="element-19">
              <span className="inline-block bg-terracotta/90 text-white text-sm font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-20">
                🔥 76% OFF — Limited Time
              </span>
              <div className="flex items-center justify-center gap-3" data-id="element-21">
                <span className="text-sage-light/50 line-through text-2xl" data-id="element-22">
                  <Price amount={originalPrice} data-id="element-23" />
                </span>
                <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-24">
                  <Price amount={price} data-id="element-25" />
                </span>
              </div>
            </div>

            <a href="https://www.gemmamama.com/cart/45458351751307:1" target="_blank" rel="noopener noreferrer" id="buy-now-btn" onClick={handleAddToCart} className="inline-flex items-center justify-center px-8 py-5 bg-terracotta text-white font-bold rounded-full shadow-lg hover:bg-terracotta-hover hover:scale-105 transition-all duration-300 text-lg md:text-xl group" data-id="element-26">
              Get Complete Ebook guide Now — <Price amount={price} data-id="element-27" />
            </a>

            <p className="mt-6 text-sm text-sage-light/50" data-id="element-28">
              Instant Digital Download • Secure Checkout
            </p>
          </div>
        </div>
      </div>
    </section>;
}